import MainLayout from "pmsa-polaris/components/MainLayout"

import DetailsTable from "./TasksTable"

const TableView: React.FC = () => (
  <MainLayout contentType="table">
    <br />
    <DetailsTable />
  </MainLayout>
)

export default TableView
